import { Injectable } from "@angular/core";
import { AdaptClientConfiguration, AdaptProject } from "@common/configuration/adapt-client-configuration";
import { LocalStorage } from "@common/lib/storage/local-storage";
import { BaseInitialisationService } from "@common/service/base-initialisation.service";
import { UserService } from "@common/user/user.service";

@Injectable({
    providedIn: "root",
})
export class ThemeService extends BaseInitialisationService {
    private static themeIdKey = "themeId";
    private themeId = 0;

    public constructor(private userService: UserService) {
        super();
    }

    public init() {
        this.setThemeForCurrentPerson();
        this.userService.userChanged$.subscribe(() => this.setThemeForCurrentPerson());
    }

    public setThemeForCurrentPerson() {
        let themeId: number;
        if (this.userService.currentPerson) {
            themeId = this.userService.currentPerson.preferences?.themeId ?? 0;
        } else {
            themeId = LocalStorage.get<number>(ThemeService.themeIdKey) || 0;
        }

        this.setTheme(themeId);
    }

    public get currentTheme() {
        // nimbus has its own theme
        if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Nimbus) {
            return "blue";
        }

        if (this.themeId) {
            switch (this.themeId) {
                case 1:
                    return "green";
                case 2:
                    return "burgundy";
                default:
                    this.log.error("Unknown theme id", this.themeId);
            }
        }

        // not set or invalid - use defaults
        if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Alto) {
            return "burgundy";
        } else if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Cumulus) {
            return "green";
        } else {
            throw new Error("Unknown project name");
        }
    }

    public get currentThemeSwatch() {
        // nimbus has its own theme
        if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Nimbus) {
            return "blue-swatch";
        }

        if (this.themeId) {
            switch (this.themeId) {
                case 1:
                    return "green-swatch";
                case 2:
                    return "burgundy-swatch";
                default:
                    this.log.error("Unknown theme id", this.themeId);
            }
        }

        // not set or invalid - use defaults
        if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Alto) {
            return "burgundy-swatch";
        } else if (AdaptClientConfiguration.AdaptProjectName === AdaptProject.Cumulus) {
            return "green-swatch";
        } else {
            throw new Error("Unknown project name");
        }
    }

    public setTheme(themeId: number) {
        this.themeId = themeId;
        LocalStorage.set(ThemeService.themeIdKey, themeId);

        const selector = document.querySelector("[data-bs-theme]");
        if (selector) {
            selector.setAttribute("data-bs-theme", this.currentTheme);
        }
    }
}
